<template>
  <div class="app-news">
    <div class="app-widget-container">
      <div class="news-title">
        <h2>{{ prodForm.prodTitle }}</h2>
      </div>
    </div>
    <div style="padding: 50px 130px;">
      <div class="news-desc">
        <span style="font-size: 21px;">{{ prodForm.prodDesc }}</span>
      </div>
      <div class="news-infos" v-html="prodForm.prodContent">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      prodForm: {
        prodId:'',
        prodTitle: '',
        prodDesc: '',
        prodContent: '',
        prodType: '',
        createdTime: ''
      }
    }
  },
  created() {
    debugger
    this.prodForm.prodId = this.$route.params.id
    this.handleSearch()
  },
  methods: {
    handleSearch() {
      this.$axios.get('/api/products/findDetail/'+this.prodForm.prodId).then(res => {
        if (res.data.code = 200) {
          this.prodForm = res.data.result || {}
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.app-news {
  padding: 0px;
  min-height: 600px;
  background-color: #fff;
}
.app-news .app-widget-container {
	padding:135px 30px;
	background:url(../assets/img/blog-img_1.png);
	background-repeat:no-repeat;
	background-position:center;
	// background-attachment:fixed;
	background-size:100% 100%;
	-webkit-background-size:100% 100%;
	-moz-background-size:100% 100%;
	-o-background-size:100% 100%;
	-moz-background-size:100% 100%;
	-ms-background-size:100% 100%;
}
.app-news  .app-widget-container .news-title {
  text-align: center;
  color: white;
}
.app-news .news-desc {
  text-align: center;
  max-width: 1140px;
  margin-right: auto;
  margin-left: auto;
}
.app-news .news-infos {
    flex: 1;
    height: 100%;
    margin-top: 2.5rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #F6F6F6;
    box-shadow: 1px 0px 10px 1px #2b2b2b;
    transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
    padding: 30px 0px 30px 0px;

    .lang{
      font-size: 0.191rem;
      line-height: 18px;
      color: #000;

    }
    .author{

      padding-top:6px;
      font-size: 0.191rem;
      color: #000;
      width: 100%;
      text-align: right;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/ProdDetail.vue